import React, { useEffect, useRef, useState } from "react";
import tw from "twin.macro";
import { likeCount, wishCount } from "../api/ProducDetailsApi";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
// import Noimg from "../images/no_img.jpg";
import share from "../images/assets/share.svg"
import { getProduct } from "api/ProductApi";
import {
  filterFormatToDate,
  YEAR_WISE_FORMAT,
} from "utility/Constant";
import styled from "styled-components";
import {
  getAddToCart,
  getBranchId,
  getCustomerId,
  setAddToCart,
} from "../utility/HeaderConfig.js";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
// import Pincode from "components/Pincode";
import BookAppointmentButton from "components/BookAppointmentButton";
import ProductPriceDetails from "components/ProductPriceDetails";
import { useCartContext } from "context/UseCartContext";
import RelatedProduct from "components/RelatedProduct";
// import ReactImageMagnify from 'react-image-magnify';
import moment from "moment";
import { branchdetails } from "api/BranchDetailsApi";
import { ECommerce } from "api/AppConfigApi";
import { createCustomerLike, createCustomerWish, deleteCustomerLike, deleteCustomerWish } from "api/Like&WishCountApi";
import ZoomableImage from "./ZoomableImage";
import Pincode from "components/Pincode";
import Modal from "react-bootstrap/Modal";
import logo206 from "../images/assets/copyLink.png"
import logo205 from "../images/assets/WhatsApp.jpeg"


const StyledDiv = tw.div`font-display overflow-hidden `;

const AccordionButton = styled.button`
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  transition: background-color 0.4s;

  &:hover {
    background-color: #ccc;
  }

  &.active {
    background-color: #ccc;
  }
`;

const Panel = styled.div`
  padding: 0 18px;
  background-color: white;
  display: ${(props) => (props.active ? "block" : "none")};
  overflow: hidden;
  transition: max-height 0.2s ease-out;
`;


export default ({ configImages }) => {
  const params = useParams();
  const catId = params?.categId === 'fromExclusive' ? params?.id : params?.categId;
  const prdctId = params?.id;
  const [Details, setDetails] = useState([]);
  const [otherCharge, setOtherCharge] = useState([]);
  const [productId, setProductId] = useState("");
  const [additionalCharge, setAdditionalCharge] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [Img, setImg] = useState([]);
  const [Spec, setSpec] = useState([]);
  const [LikeCount, setLikeCount] = useState("");
  const [WishCount, setWishCount] = useState("");
  const [banner, setBanner] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isActiveToggle, setIsActiveToggle] = useState(false);
  const [secMetalDetail, setSecMetalDetail] = useState([]);
  const [branch, setBranch] = useState({});
  const [isShow, setIsShow] = useState(false);
  const [viewCart, setViewCart] = useState([]);
  const navigate = useNavigate();
  const [productFilter, setProductFilter] = useState({});
  // const [branchName, setBranchName ] = useState("");
  const history = useNavigate();
  const location = useLocation();
  const { dispatch } = useCartContext();
  const [likeState, setLikeState] = useState({});
  const [wishState, setWishState] = useState({});
  const [copiedLink, setCopiedLink] = useState('');
  const [currentImg, setCurrentImg] = useState(Img[0]);
  const [showModal, setShowModal] = useState(false);
  const [showCopyLink, setShowCopyLink] = useState(false);
  const [zoom, setZoom] = useState(false);

  useEffect(() => {
    // getProductIdParsing();
    getBanner();
    getBrachDataList();
    //eslint-disable-next-line
  }, []);

  const getBrachDataList = () => {
    branchdetails(getBranchId()).then((data) => {
      setBranch(data.response);
    });
  };

  useEffect(() => {
    getProductIdParsing();
    getAddToCartDetails();
    //eslint-disable-next-line
  }, [location.state]);

  const handleOpenDetails = (categoryItem) => {
    window.open(`/ProductDetails/${categoryItem.id}`, "_blank");
  };

  useEffect(() => {
    if (Img.length > 0) {
      setCurrentImg(Img[0]);
    }
  }, [Img]);

  const getProductIdParsing = () => {
    let productId = "";
    if (!location.state) {
      const pathName = location.pathname.split("/");
      productId = pathName[2];
    } else {
      productId = location.state?.categoryItem?.id;
    }
    setProductId(productId);
    getRateApi(productId);
    likeCountDetails(productId);
    wishCountDetails(productId);
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "productDetails") {
          setBanner(data.value);
        }
      });
  };

  const getRateApi = async (productId) => {
    let allOtherCharges = [];
    let stoneChargeList = [];
    let secMetalDetails = [];
    let currentDate = moment().format(YEAR_WISE_FORMAT);
    let filter = {
      branch: getBranchId(),
      beforeCreatedAt: filterFormatToDate(currentDate),
      id: productId,
    };
    dispatch({ type: "DAYCLOSED", payload: filterFormatToDate(currentDate) });
    await getProduct(10, filter)?.then((data) => {
      let imageData = [];
      const productResponse = data.response.content[0];
      const imageResponse = data.response.content[0];
      if (
        imageResponse !== null &&
        imageResponse !== "" &&
        imageResponse !== "-"
      ) {
        const img = imageResponse?.images ?? "";
        let productImg = img.split("@#@").filter((item) => item !== "");
        setImg(productImg);
        setCurrentImg(productImg);
      } else {
        imageData.push({
          image: currentImg,
        });
        setImg(imageData);
        setCurrentImg(currentImg);
      }
      setSpec(data?.response?.prodSpecMappingList ?? "");
      let otherChargeJSON = data?.response?.content?.length > 0 ? JSON.parse(
        data?.response?.content[0]?.otherCharges
      ) : [];
      let secMetalJSON = data?.response?.content?.length > 0 ? JSON.parse(
        data?.response?.content[0]?.secMetalDetails
      ) : '';
      secMetalJSON?.length > 0 && secMetalJSON?.forEach((item) => {
        secMetalDetails?.push(item);
      });
      let datas = otherChargeJSON?.length > 0 && otherChargeJSON.filter((item) => {
        if (
          item.remarks === "stonecharge" ||
          item.remarks === "handlingcharge" ||
          item.remarks === "stampingcharge" ||
          item.remarks === "additionalcharge" ||
          item.remarks === "freightCharges"
        ) {
          return item;
        }
      });
      allOtherCharges = datas;
      setAdditionalCharge(allOtherCharges);
      otherChargeJSON?.length > 0 && otherChargeJSON.forEach((otherChargeItem) => {
        if ({}.hasOwnProperty.call(otherChargeItem, "stone")) {
          if (otherChargeItem?.stone?.length > 0) {
            stoneChargeList = otherChargeItem.stone;
          }
        }
      });

      let Rate = data.response?.content[0] ?? "";
      let ProductDetail = productResponse;
      let Certificate;
      ProductDetail?.length > 0 && JSON.parse(ProductDetail?.otherCharges).map((value) => {
        if (value?.stone && value?.stone?.length > 0) {
          Certificate = value.stone[0].certificatenumber;
        }
      });
      const weight = ProductDetail?.length > 0 && JSON.parse(ProductDetail.weight);
      setDetails({
        ...ProductDetail,
        ...Rate,
        //  ...BasePrice,
        Certificate,
        weight,
      });
      setLoader(true);
      setOtherCharge(stoneChargeList);
      setSecMetalDetail(secMetalDetails);
    });
  };

  const likeCountDetails = async (countId) => {
    try {
      const data = await likeCount(countId);
      const likeData = data.response;
      setLikeCount(likeData > 0 ? likeData : 0);
    } catch (error) {
      console.error("Error fetching like count:", error);
      setLikeCount(0);
    }
  };

  const wishCountDetails = async (countId) => {
    try {
      const data = await wishCount(countId);
      const wishData = data.response;
      setWishCount(wishData > 0 ? wishData : 0);
    } catch (error) {
      console.error("Error fetching wish count:", error);
      setWishCount(0);
    }
  };

  const addToCart = (productCode) => {
    const productData = JSON.parse(
      getAddToCart() !== undefined ? getAddToCart() : "[]"
    );
    let products = [];
    products = productData;
    if (products.length < 3 && products.length !== 3) {
      products.push(Details);
      let storeCardItem = JSON.parse(
        getAddToCart() !== undefined ? getAddToCart() : "[]"
      );
      const validateProduct = storeCardItem.some(
        (item) => item.productCode === productCode
      );

      if (!validateProduct) {
        setAddToCart(JSON.stringify(products));
        // setTimeout(() => {
        dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
        // }, 0);
        toast.success("Product Added To The Cart", {
          duration: 1000,
          position: "top-right",
        });
      } else {
        toast.error("Product Already Added To The Cart !", {
          duration: 3000,
          position: "top-right",
        });
      }
    } else {
      toast.error(
        "Cart Limit Reached Your Cart Can Only Contain Up To Three Items !",
        {
          duration: 3000,
          position: "top-right",
        }
      );
    }
  };

  const buynow = () => {
    if (getCustomerId()) {
      history("/CheckoutPage", { state: { Details, prdctId, isBuyNow: 'buyNow' } });
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  }

  // const buynow = (productCode) => {
  //   const productData = JSON.parse(
  //     getAddToCart() !== undefined ? getAddToCart() : "[]"
  //   );
  //   let products = [];
  //   products = productData;
  //   if (true) {
  //     products.push(Details);
  //     let storeCardItem = JSON.parse(
  //       getAddToCart() !== undefined ? getAddToCart() : "[]"
  //     );
  //     const validateProduct = storeCardItem.some(
  //       (item) => item.productCode === productCode
  //     );
  //     if (!validateProduct) {
  //       if (getCustomerId()) {
  //         // setAddToCart(JSON.stringify(products));
  //         // dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
  //         history("/CheckoutPage", { state: { Details, prdctId } });
  //       } else {
  //         dispatch({ type: "MODAL", payload: "login" });
  //       }
  //     } else {
  //       if (getCustomerId()) {
  //         history("/CheckoutPage", { state: { Details, prdctId } });
  //       } else {
  //         dispatch({ type: "MODAL", payload: "login" });
  //       }
  //     }
  //   } else {
  //     toast.error(
  //       "Cart Limit Reached Your Cart Can Only Contain Up To Three Items !",
  //       {
  //         duration: 3000,
  //         position: "top-right",
  //       }
  //     );
  //   }
  // };

  const thumb = (index) => {
    setCurrentImg(Img[index]);
  };

  const toggleAccordion = () => {
    setIsActive(!isActive);
  };

  const toggleAccordionToggle = () => {
    setIsActiveToggle(!isActiveToggle);
  };

  const getAddToCartDetails = async () => {
    let filter = "savings_scheme_app";
    ECommerce(filter).then((data) => {
      let showButton = JSON.parse(data.response.moduleField);
      let isShowData = showButton.filter(
        (item) => item.key === "IS_ECOMM_ADD_TO_CART_ENABLED"
      );
      setIsShow(isShowData[0]?.value);
    });
  };



  const [toggle, setToggle] = useState(true);


  useEffect(() => {
    const interval = setInterval(() => {
      setToggle((prev) => !prev);
    }, 2000);

    return () => clearInterval(interval);
  }, []);


  const [countdown, setCountdown] = useState("");

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const imageRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!zoom) return;

    const container = e.currentTarget;
    const img = imageRef.current;
    const containerRect = container.getBoundingClientRect();

    const mouseX = e.clientX - containerRect.left;
    const mouseY = e.clientY - containerRect.top;

    const moveableX = img.offsetWidth - containerRect.width;
    const moveableY = img.offsetHeight - containerRect.height;

    const x = -(mouseX / containerRect.width) * moveableX;
    const y = -(mouseY / containerRect.height) * moveableY;

    const clampedX = Math.max(Math.min(x, 0), -moveableX);
    const clampedY = Math.max(Math.min(y, 0), -moveableY);

    setPosition({
      x: clampedX,
      y: clampedY
    });
  };

  const handleMouseLeave = () => {
    if (zoom) {
      setPosition({ x: 0, y: 0 });
    }
  };

  useEffect(() => {
    const updateCountdown = () => {
      const cutoffTime = new Date();
      cutoffTime.setHours(18, 30, 0);
      const now = new Date();

      if (now > cutoffTime) {
        cutoffTime.setDate(cutoffTime.getDate() + 1);
      }

      const timeDiff = cutoffTime - now;

      const hours = String(Math.floor(timeDiff / (1000 * 60 * 60))).padStart(
        2,
        "0"
      );
      const minutes = String(
        Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
      ).padStart(2, "0");
      const seconds = String(
        Math.floor((timeDiff % (1000 * 60)) / 1000)
      ).padStart(2, "0");

      setCountdown(`${hours}:${minutes}:${seconds}`);
    };

    const intervalId = setInterval(updateCountdown, 1000);
    updateCountdown();

    return () => clearInterval(intervalId);
  }, []);


  const [is1, setIs1] = useState(false);
  const [is2, setIs2] = useState(false);
  const [is3, setIs3] = useState(false);
  const [is4, setIs4] = useState(false);


  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const currentPath = window.location.href;
    const link = currentPath;
    // const encodedLink = encodeURIComponent(currentPath);
    navigator.clipboard.writeText(link).then(() => {
      setCopiedLink(link);
      setShowCopyLink(false);
      toast.success('Link copied!');
      navigate(`/ProductDetails/${productId}`);
    });
  };

  const shareToWhatsApp = () => {
  const currentUrl = window.location.href;
  
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(currentUrl)}`;
  window.open(whatsappUrl, "_blank");
};

  const handleClickButton = () => {
    navigate("/CheckoutPage", {
    });
  }

  const wishCountFunc = (Details) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = Details.productId || Details.id;
      setWishState((prevState) => {
        const nextState = !prevState[productId];
        const query = `customerId=${getCustomerId()}&productId=${productId}`;
        if (nextState) {
          createCustomerWish(`${query}&remark=liked`);
          setWishCount((prev) => prev + 1);
        } else {
          deleteCustomerWish(query);
          setWishCount((prev) => prev - 1);
        }
        return { ...prevState, [productId]: nextState };
      });
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const likeCountFunc = (Details) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = Details.productId || Details.id;
      setLikeState((prevState) => {
        const nextState = !prevState[productId];
        const query = `customerId=${getCustomerId()}&productId=${productId}`;
        if (nextState) {
          createCustomerLike(`${query}&remark=liked`);
          setLikeCount((prev) => prev + 1);
        } else {
          deleteCustomerLike(query);
          setLikeCount((prev) => prev - 1);
        }
        return { ...prevState, [productId]: nextState };
      });
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  return (
    <StyledDiv>
      <Toaster position="top-right" />
      {banner && banner.length > 0 ? (
        // <img src={banner} alt="Jewellery Product Details" className="w-100" />
        <p></p>
      ) : (
        <Skeleton tw="w-full" style={{ height: "200px" }} />
      )}
      <div className="px-sm-5 px-0 mb-3" tw="text-lg pt-3" style={{ position: 'relative', zIndex: 1, fontSize: "9px", color: " #585858" }}>
        <Link to="/" tw="mx-3 no-underline text-black">
          <small tw="text-lg">Home</small>
        </Link> /
        <small tw="text-lg"
          style={{ color: "#f0b917", textTransform: "capitalize" }}
          className="mx-3"> {Details?.productName?.toLowerCase()}</small>
        {/* <span tw="ml-3 text-custom-100 capitalize tracking-wide ">
          {Details.productName?.toLowerCase()}
        </span> */}
      </div>
      <section className="pb-3 position-relative my-0" tw="sm:my-10" >
        <div className="container-lg">
          <div className="row justify-content-evenly">
            {isLoader ? (
              <>
                <div className="col-md-5 col-12">
                  <div onClick={() => setShowModal(true)} style={{ cursor: "pointer" }}>
                    <ZoomableImage
                      src={currentImg}
                      previewWidth={350}
                      previewHeight={350}
                      zoomedWidth={500}
                      zoomedHeight={500}
                    />                  
                    </div>
                  <div className="thumbnail-images d-flex flex-wrap gap-2 mt-3">
                    {Img.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        onClick={() => setCurrentImg(image)}
                        className={`img-thumbnail ${currentImg === image ? "border border-primary" : ""
                          }`}
                        style={{ width: 60, height: 60, objectFit: "cover", cursor: "pointer" }}
                      />
                    ))}
                  </div>
                </div>

             <Modal
  show={showModal}
  centered
  size="xl"
  onHide={() => {
    setShowModal(false);
  }}
  dialogClassName="modal-fixed-size"
>
  <Modal.Body
    className="position-relative p-0"
    style={{
      minHeight: "80vh",
      maxHeight: "80vh",
      display: "flex",
      flexDirection: "column"
    }}
  >
    <button
      type="button"
      className="btn-close position-absolute"
      style={{
        top: "15px",
        right: "15px",
        zIndex: 10,
        backgroundSize: "1rem"
      }}
      onClick={() => {
        setShowModal(false);
      }}
      aria-label="Close"
    />

    <div className="p-3 border-bottom">
      <h5 className="mb-0 text-center">{Details.productName}</h5>
    </div>

    <div
      className="flex-grow-1 d-flex justify-content-center align-items-center"
      style={{
        // overflow: "auto",
        padding: "20px"
      }}
    >
      <img
        src={currentImg}
        alt="modal-main"
        style={{
          width: "auto",
          height: "350px",
          // objectFit: "contain"
          // height: "auto"
        }}
      />
    </div>

    <div
      className="border-top p-3"
      style={{
        height: "120px",
        overflowX: "auto",
        overflowY: "hidden",
        flexShrink: 0
      }}
    >
      <div className="d-flex justify-content-center gap-2">
        {Img.map((image, index) => (
          <img
            key={index}
            src={image}
            onClick={() => {
              setCurrentImg(image);
            }}
            className={`img-thumbnail ${currentImg === image ? "border border-primary" : ""}`}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
              cursor: "pointer",
              flexShrink: 0
            }}
          />
        ))}
      </div>
    </div>
  </Modal.Body>
</Modal>
                <div className="col-md-6" tw="sm:py-0 py-10">
                  <h4 className="mt-4">
                    <b
                      style={{
                        fontSize: "25px",
                        color: "#f0b917",
                        fontFamily: "Cormorant, serif",
                        display: "block",
                      }}
                    >
                      {Details.productName}   <button onClick={handleOpen}
                        style={{
                          border: "2px solid white ", borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px",
                          borderTopRightRadius: "15px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)", color: " #585858",
                          borderBottomRightRadius: "15px", width: 40, height: 40,
                        }}> <img src={share}></img>
                      </button>
                    </b>
                    <div className="pt-2">
                      <i
                        className={`bi ${wishState[Details.id] ? "bi-heart-fill" : "bi-heart"} me-1`}
                        style={{ fontSize: '1rem' }}
                        onClick={() => wishCountFunc(Details)}
                      ></i>
                      <span style={{ fontSize: '0.9rem' }}>{WishCount} Wish</span>
                      <i
                        className={`bi ${likeState[Details.id] ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} ms-3 me-1`}
                        style={{ fontSize: '1rem' }}
                        onClick={() => likeCountFunc(Details)}
                      ></i>
                      <span style={{ fontSize: '0.9rem' }}>{LikeCount} Like</span>
                    </div>
                  </h4>
                  <table tw="leading-9" className="col-md-12 col-lg-6">
                    <tr tw="mb-3">
                      <td> Product Code</td>:
                      <td>{Details.productCode}</td>
                    </tr>
                    <tr>
                      <td>Product Type</td>:
                      <td>
                        {Details.productTypeName}
                        {Details?.productTypeName?.toLowerCase() ===
                          "silver" ? null : (
                          <div
                            className="badge"
                            tw="bg-yellow-600 p-1"
                            style={{ marginLeft: "5px" }}
                          >
                            {" "}
                            {Details.weight.purity}
                          </div>
                        )}
                      </td>
                    </tr>
                    {Details.brand !== "" ? (
                      <tr>
                        <td tw="px-2">Brand</td>:
                        <td tw="px-2">{Details.brand}</td>
                      </tr>
                    ) : null}
                  </table>
                  <div className="col-md-6  col-lg-6 col-xl-7 d-inline"
                    style={{ marginTop: '-70px' }}>
                    <h6 tw="text-custom-100  mt-3 mb-3">
                      PRICE DETAILS :
                    </h6>
                    <table className="table table-bordered mb-2">
                      <thead>
                        <tr>
                          <th>Sub-Total</th>
                          <th>Tax</th>
                          <th>Grand Total</th>
                        </tr>
                      </thead>
                      <tbody className="border-top-0 ">
                        <tr>
                          <td>₹{(
                            (Details?.basePrice || 0) +
                            (Details?.diamondTotal || 0) +
                            (Details?.platinumTotal || 0) +
                            (Details?.secGoldTotal || 0)
                          ).toFixed(2)}</td>
                          <td>₹{(
                            (Details?.saleTaxList?.[0]?.amount || 0) +
                            (Details?.saleTaxList?.[1]?.amount || 0) +
                            (parseFloat(Details?.secGoldTax) || 0) +
                            (Details?.diamondTax || 0) +
                            (Details?.platinumTax || 0)
                          ).toFixed(2)}</td>
                          <td> ₹{(
                            (Details?.basePrice || 0) +
                            (Details?.diamondTotal || 0) +
                            (Details?.platinumTotal || 0) +
                            (Details?.secGoldTotal || 0) +
                            (Details?.saleTaxList?.[0]?.amount || 0) +
                            (Details?.saleTaxList?.[1]?.amount || 0) +
                            (Details?.secGoldTax || 0) +
                            (Details?.diamondTax || 0) +
                            (Details?.platinumTax || 0) +
                            (Details?.hallmarkCharge || 0) +
                            (Details?.hallmarkCharge || 0) * (Details?.hmTaxPercentage / 100 || 0)
                          ).toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="row d-inline">

                    <div className="d-inline gap-4 mt-3">
                      {/* <button
                          style={{
                            border: "2px solid white ", borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px",
                            borderTopRightRadius: "15px", color: " #585858", width: 90, height: 30,
                            borderBottomRightRadius: "15px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)"
                          }}
                          > 
                          <small>4.8  <BsStarFill style={{ color: 'gold' }} /> 21 </small>
                        </button> */}


                      {/* <a href="#product-info">
                          <button
                            style={{
                              border: "2px solid white ", borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px",
                              borderTopRightRadius: "15px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)", color: " #585858",
                              borderBottomRightRadius: "15px", width: 120, height: 30,
                            }}> <small> <span>View Details ↓ </span></small>
                          </button> </a> */}

                    </div>

                    <div className="d-flex gap-3 mt-1 " style={{
                      textAlign: "center",
                      display: "block",
                      margin: "auto",
                    }}>
                      <Modal show={open} onHide={handleClose} centered size="sm">
  <Modal.Header closeButton>
    <Modal.Title>Share Via:</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="d-flex justify-content-center gap-4 align-items-center">
      <div className="text-center">
        <img 
          onClick={shareToWhatsApp}
          src={logo205} 
          className="cursor-pointer d-block mx-auto mb-2"
          style={{width: "40px", height: "40px"}}
          alt="Share on WhatsApp"
        />
        <h6 className="mb-0">
          <small>WHATSAPP</small>
        </h6>
      </div>

      <div 
        onClick={handleCopy} 
        className="text-center"
        style={{ cursor: "pointer" }}
      >
        <img 
          src={logo206} 
          className="d-block mx-auto mb-2"
          style={{width: "40px", height: "40px"}}
          alt="Copy link"
        />
        <h6 className="mb-0">
          <small className={copied ? "text-success" : ""}>
            {copied ? "Link copied!" : "COPY LINK"}
          </small>
        </h6>
      </div>
    </div>
  </Modal.Body>
</Modal>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8 col-lg-8 col-xl-8">
                      <div className="py-2">
                        {Details?.stockStatus?.toLowerCase() === 'sold' ? null : (
                          <>
                            <div className="price-container">
                              <span className="price-label">Price :</span>

                              <div className="price-section">
                                {Details.total !== Details.discountAmt && Details.discountAmt > 0 ? (
                                  <>
                                    <span className="final-price">₹{Details.discountAmt.toFixed(2)}</span>
                                    <span className="original-price">₹{Details.total.toFixed(2)}</span>
                                    <span className="discount-text">
                                      {Details.discountType === 'percentage'
                                        ? `${Details.discountValue}% off`
                                        : `${Details.discountValue} Rs off`}
                                    </span>
                                  </>
                                )
                                  :
                                  <span className="final-price">₹{Details.total ? Details.total.toFixed(2): ''}</span>
                                }
                              </div>
                            </div>

                            <small>*Inclusive of all taxes</small>
                          </>
                        )}
                      </div>

                      {Details.status === "Sale" ? (
                        <div tw="text-green-600 py-1">
                          <h6 tw="mb-1">
                            <span>
                              Available at {Details.branchName} Branch
                            </span>
                          </h6>
                        </div>
                      ) : null}
                      {Details.Certificate > 0 && (
                        <p tw="text-sm my-2">
                          Certificate No : {Details.Certificate}
                        </p>
                      )}
                    </div>
                    {/* <div className="col-md-6  col-lg-6 col-xl-7">
                      <h6 tw="text-custom-100  mt-3 mb-3">
                        Weight Details (gms)
                      </h6>
                      <table className="table table-bordered mb-2">
                        <thead>
                          <tr>
                            <th>G.WT</th>
                            <th>L.WT</th>
                            <th>N.WT</th>
                          </tr>
                        </thead>
                        <tbody className="border-top-0 ">
                          <tr>
                            <td>{Details?.weight?.grossWeight}</td>
                            <td>{Details?.weight?.lessWeight}</td>
                            <td>{Details?.weight?.netWeight}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div> */}
                    {/* <div className="col-md-6  col-lg-6 col-xl-7 d-inline"
                     style={{    marginTop: '-70px'}}>
                      <h6 tw="text-custom-100  mt-3 mb-3">
                        PRICE DETAILS :
                      </h6>
                      <table className="table table-bordered mb-2">
                        <thead>
                          <tr>
                            <th>Sub-Total</th>
                            <th>Tax</th>
                            <th>Grand Total</th>
                          </tr>
                        </thead>
                        <tbody className="border-top-0 ">
                          <tr>
                            <td>₹{(
                              (Details?.basePrice || 0) +
                              (Details?.diamondTotal || 0) +
                              (Details?.platinumTotal || 0) +
                              (Details?.secGoldTotal || 0)
                            ).toFixed(2)}</td>
                            <td>₹{(
                              (Details?.saleTaxList?.[0]?.amount || 0) +
                              (Details?.saleTaxList?.[1]?.amount || 0) +
                              (parseFloat(Details?.secGoldTax) || 0) +
                              (Details?.diamondTax || 0) +
                              (Details?.platinumTax || 0)
                            ).toFixed(2)}</td>
                            <td> ₹{(
                              (Details?.basePrice || 0) +
                              (Details?.diamondTotal || 0) +
                              (Details?.platinumTotal || 0) +
                              (Details?.secGoldTotal || 0) +
                              (Details?.saleTaxList?.[0]?.amount || 0) +
                              (Details?.saleTaxList?.[1]?.amount || 0) +
                              (Details?.secGoldTax || 0) +
                              (Details?.diamondTax || 0) +
                              (Details?.platinumTax || 0) +
                              (Details?.hallmarkCharge || 0) +
                              (Details?.hallmarkCharge || 0) * (Details?.hmTaxPercentage / 100 || 0)
                            ).toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div> */}
                  </div>
                  <p tw="text-sm  leading-7" className="line-clamp ">
                    {Details.description !== null &&
                      Details.description !== "-" &&
                      Details.description !== ""
                      ? Details.description
                      : ""}
                  </p>
                  {Details.status !== "Sale" ? (
                    <p tw="text-sm  leading-7" className="line-clamp ">
                      <span style={{ color: "red" }}>
                        {" "}
                        <i class="bi bi-exclamation-circle"></i> Temporarily Out
                        of Stock :
                      </span>{" "}
                      You can still order this !
                    </p>
                  ) : null}
                  {/* {Details.pieceRate && Details.pieceRate !== "" ? (
                    <div className="row">
                      <div className="col mb-3">
                        Pcs Rate : <span>{Details.pieceRate}</span>
                      </div>
                    </div>
                  ) : null} */}
                  {Details?.stockStatus?.toLowerCase() === 'sold' ? '' : (
                    <>
                      {Details.wastageCost &&
                        Details.wastageInPer &&
                        Details.mcValue &&
                        Details.mcType !== "" ? (
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <b>Wastage</b>
                            </div>
                            <div className="col">
                              <b>Mc</b>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <p>
                                {/* {Details.wastageCost && Details.wastageInPer} % */}
                                {` ${Details.wastageValue}${Details.wastageType === "percentage"
                                  ? "%"
                                  : Details.wastageType === "pieces"
                                    ? "pcs"
                                    : Details.wastageType === "rs"
                                      ? "rs"
                                      : Details.wastageType === "mg"
                                        ? "gm"
                                        : Details.wastageType
                                  } `}{" "}
                              </p>
                            </div>
                            <div className="col">
                              <p>
                                ₹{" "}
                                {Details.netMc}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </>
                  )}
                  {additionalCharge && additionalCharge.length > 0 ? (
                    <>
                      <AccordionButton
                        onClick={toggleAccordion}
                        className={isActive ? "active" : ""}
                      >
                        Additional Charges
                      </AccordionButton>
                      <Panel active={isActive}>
                        <div className="d-flex justify-content-center mt-3">
                          <h5>
                            {" "}
                            {(additionalCharge && additionalCharge.length > 0
                              ? additionalCharge[0]?.remarks
                              : ""
                            ).toUpperCase()}{" "}
                          </h5>
                        </div>
                        <hr
                          style={{
                            backgroundColor: "red",
                            height: "2px",
                            margin: "0px",
                          }}
                        />
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <b>Charge Type</b>
                            </div>
                            <div className="col">
                              <b>Piece</b>
                            </div>
                            <div className="col">
                              <b>Charge</b>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <p className="w-50">
                                {" "}
                                {additionalCharge && additionalCharge.length > 0
                                  ? additionalCharge[0]?.type
                                  : ""}
                              </p>
                            </div>
                            <div className="col">
                              <p className="w-50">
                                {" "}
                                {additionalCharge && additionalCharge.length > 0
                                  ? additionalCharge[0]?.piece
                                  : ""}
                              </p>
                            </div>
                            <div className="col">
                              <p className="w-50">
                                {additionalCharge && additionalCharge.length > 0
                                  ? additionalCharge[0]?.charge
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Panel>
                    </>
                  ) : null}
                  {secMetalDetail && secMetalDetail.length > 0 ? (
                    <>
                      <AccordionButton
                        onClick={toggleAccordionToggle}
                        className={isActiveToggle ? "active" : ""}
                      >
                        Secondary Metal
                      </AccordionButton>
                      <Panel active={isActiveToggle}>
                        <div className="d-flex justify-content-center mt-3">
                          <h5>
                            {" "}
                            {secMetalDetail && secMetalDetail.length > 0
                              ? secMetalDetail[0]?.remarks
                              : ""}{" "}
                          </h5>
                        </div>
                        <div className="container">
                          <div className="row">
                            <div className="col">
                              <b> Metal Type :</b>{" "}
                              <span>
                                {secMetalDetail && secMetalDetail.length > 0
                                  ? secMetalDetail[0]?.productTypeName
                                  : ""}
                              </span>
                            </div>
                            <div className="col">
                              <b> Purity : </b>{" "}
                              <span>
                                {secMetalDetail && secMetalDetail.length > 0
                                  ? secMetalDetail[0]?.purityName
                                  : ""}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <b> Halmarked :</b>{" "}
                              <span>
                                {secMetalDetail && secMetalDetail.length > 0
                                  ? secMetalDetail[0]?.standardName
                                  : ""}
                              </span>
                            </div>
                            <div className="col">
                              <b> Piece :</b>{" "}
                              <span>
                                {secMetalDetail && secMetalDetail.length > 0
                                  ? secMetalDetail[0]?.piece
                                  : ""}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col">
                              <b>Net Weight : </b>{" "}
                              <span>
                                {secMetalDetail && secMetalDetail.length > 0
                                  ? secMetalDetail[0]?.weight?.netWeight
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </div>
                      </Panel>
                    </>
                  ) : null}
                  {otherCharge && otherCharge.length > 0 ? (
                    <>
                      <div className="mt-2">
                        <h4>Stone Details :</h4>
                        <hr style={{ backgroundColor: "red", height: "2px" }} />
                        <div className="d-flex justify-content-between">
                          <table className="table table-bordered mb-2">
                            <thead>
                              <tr>
                                <th>Stone Type</th>
                                <th>Pieces</th>
                                <th>Weight</th>
                                <th>Unit</th>
                                <th>Total Cost</th>
                              </tr>
                            </thead>
                            <tbody className="border-top-0" >
                              {otherCharge.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.dataName}</td>
                                  <td>{item.pieces}</td>
                                  <td>{item.grm}</td>
                                  <td>{item.typeName}</td>
                                  <td>{item.totalValue}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className="row">
                    {Spec.length > 0 && (
                      <div className="col-md-4">
                        <h6 tw="text-custom-100  mb-5">
                          Specification Details
                        </h6>

                        <table tw="leading-9" className="col-md-6 w-100">
                          {Spec.map((data, index) => (
                            <tr tw="mb-3" key={index}>
                              <td tw="px-3">
                                {data.specificationName.split("_")[0]}{" "}
                              </td>{" "}
                              :
                              <td tw="px-3">
                                {data.specificationValue !== "NA"
                                  ? data.specificationValue
                                  : "-"}
                              </td>
                            </tr>
                          ))}
                        </table>
                      </div>
                    )}
                    <div
                      className={`${Spec.length > 0 ? "col-md-8" : "col-md-12"}`}
                    >
                      <ProductPriceDetails
                        Details={Details}
                        secMetalDetail={secMetalDetail}
                      />
                    </div>
                  </div>
                  <div className="row py-0">
                    {Details.status !== "Sale" ? (''
                      // <BookAppointmentButton category={Details} />
                    ) : (
                      <>
                        {/* <Pincode /> */}
                        {/* <BookAppointmentButton category={Details} /> */}
                        {/* {!isShow && ( */}
                        <>
                          <div className="row mt-2">
                            <div className="col-12 col-lg-6 my-lg-0 my-3 d-flex">
                              <div id="holder" className="w-100">
                                <div className="button w-100" onClick={() => addToCart(Details.productCode)}>
                                  <p className="btnText m-0 h-100 d-flex justify-content-center align-items-center rounded">
                                    Add To Cart
                                  </p>
                                  <div className="btnTwo">
                                    <p className="btnText2">
                                      <i className="bi bi-cart-plus"></i>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <BookAppointmentButton category={Details} />

                            {/* <div className="col-12 col-lg-6 d-flex">
                              <div id="holder" className="w-100">
                                <div className="button w-100" onClick={() => buynow(Details.productCode)}>
                                  <p className="btnText m-0 h-100 d-flex justify-content-center align-items-center rounded">
                                    Buy now
                                  </p>
                                  <div className="btnTwo">
                                    <p className="btnText2">
                                      <i className="bi bi-cash"></i>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </>
                        {/* )} */}
                      </>
                    )}
                  </div>
                  {/* <div className="row" style={{ marginTop: "-40px" }}>
                    <div className="mt-5">
                      <button className="shipping-info-button" style={{
                        border: "1px solid rgb(221, 220, 220)",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                        color: " #585858",
                        borderRadius: "10px",
                        width: 420,
                        padding: "8px",
                        height: "95px"
                      }}>
                        <h6 className="text-black text-start">
                          <div className="d-flex gap-2">
                            <img className="mt-1" src={ship} alt="Shipping icon" />
                            <span className="mt-1" style={{ fontFamily: 'Lato, sans-serif' }}>
                              <small><span> Free Shipping Tomorrow</span></small>
                            </span>
                          </div>
                        </h6>

                        <h6 style={{ fontFamily: "Lato, sans-serif" }}>
                          <small><span>Order within {countdown} to enjoy 24-hours shipping!</span></small>
                        </h6>

                        <h6>
                          <small>
                            <a
                              href="#"
                              style={{ fontFamily: "Lato, sans-serif" }}
                              onClick={() => history("/TermsConditions")}
                            >
                              T&C Apply
                            </a>
                          </small>
                        </h6>
                      </button>
                    </div>
                  </div> */}
                </div>
                <div style={{ width: 1300, fontFamily: "sans-serif" }} id="product-info">
                  {/* <div className="container mt-5">
                    <h3 className="text-center">Product Information</h3>
                    <span className="d-block border-bottom border-info mt-1 mx-auto" style={{ width: "8%" }}></span>

                    <div className="row align-items-center mt-4">
                      <div className="col-12 col-md-4 text-center mb-3 mb-md-0">
                        <img src={currentImg} alt="Product" style={{ width: 150, maxWidth: "100%" }} />
                      </div>

                      <div className="col-12 col-md-8">
                        <p className="lh-lg">
                          Indian jewellers bring centuries of craftsmanship and tradition to every intricate design.
                          From timeless gold pieces to contemporary diamond creations, they offer elegance for every occasion.
                          Renowned for quality and authenticity, Indian jewellers celebrate the rich heritage of Indian culture.
                        </p>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="container"> */}
                  {/* <div className="row justify-content-center align-items-stretch"> */}

                  {/* Left Side: PRICE DETAILS */}
                  {/* <div className="col-12 col-md-6 col-xl-5 mb-4 d-flex">
                        <section
                          className="w-100"
                          style={{
                            backgroundColor: "#f9f9f9",
                            padding: "13px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                          }}
                        >
                          <h6 className="text-black mb-4 mt-2">PRICE DETAILS :</h6>
                          <table className="table table-bordered text-uppercase w-100">
                            <tbody>
                              <tr>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <small className="w-50">Sub-Total</small>
                                    <small className="w-50 text-end">
                                      ₹{(
                                        (Details?.basePrice || 0) +
                                        (Details?.diamondTotal || 0) +
                                        (Details?.platinumTotal || 0) +
                                        (Details?.secGoldTotal || 0)
                                      ).toFixed(2)}
                                    </small>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <small className="w-50">Tax <span style={{ color: "red" }}>*</span></small>
                                    <small className="w-50 text-end">
                                      ₹{(
                                        (Details?.saleTaxList?.[0]?.amount || 0) +
                                        (Details?.saleTaxList?.[1]?.amount || 0) +
                                        (parseFloat(Details?.secGoldTax) || 0) +
                                        (Details?.diamondTax || 0) +
                                        (Details?.platinumTax || 0)
                                      ).toFixed(2)}
                                    </small>
                                  </div>
                                </td>
                              </tr>
                              {Details?.hallmarkCharge > 0 && (
                                <tr>
                                  <td>
                                    <div className="d-flex justify-content-between">
                                      <small className="w-50">
                                        {Details?.hmTaxPercentage > 0
                                          ? "Hallmark Charge with tax"
                                          : "Hallmark Charge"}
                                      </small>
                                      <small className="w-50 text-end">
                                        ₹{(
                                          Details.hallmarkCharge +
                                          Details.hallmarkCharge * (Details.hmTaxPercentage / 100)
                                        ).toFixed(2)}
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td>
                                  <div className="d-flex justify-content-between">
                                    <small className="w-50" style={{ color: "#f0b917" }}>Grand Total</small>
                                    <small className="w-50 text-end">
                                      ₹{(
                                        (Details?.basePrice || 0) +
                                        (Details?.diamondTotal || 0) +
                                        (Details?.platinumTotal || 0) +
                                        (Details?.secGoldTotal || 0) +
                                        (Details?.saleTaxList?.[0]?.amount || 0) +
                                        (Details?.saleTaxList?.[1]?.amount || 0) +
                                        (Details?.secGoldTax || 0) +
                                        (Details?.diamondTax || 0) +
                                        (Details?.platinumTax || 0) +
                                        (Details?.hallmarkCharge || 0) +
                                        (Details?.hallmarkCharge || 0) * (Details?.hmTaxPercentage / 100 || 0)
                                      ).toFixed(2)}
                                    </small>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </section>
                      </div> */}

                  {/* Right Side: OTHER DETAILS (Same Height) */}
                  {/* <div className="col-12 col-md-6 col-xl-5 mb-4 d-flex">
                        <section
                          className="w-100"
                          style={{
                            backgroundColor: "#f9f9f9",
                            padding: "13px",
                            border: "1px solid #e0e0e0",
                            borderRadius: "6px",
                          }}
                        >
                          <h6 className="text-black mb-4 mt-2">OTHER DETAILS :</h6>
                          <div style={{ backgroundColor: "white", padding: "10px", borderRadius: "4px" }}>
                            <div className="d-flex justify-content-between py-2 border-bottom">
                              <div>Wastage</div>
                              <div>
                                {`${Details?.wastageValue || 0}${Details?.wastageType === "percentage"
                                  ? "%"
                                  : Details?.wastageType === "pieces"
                                    ? "pcs"
                                    : Details?.wastageType === "rs"
                                      ? "rs"
                                      : Details?.wastageType === "mg"
                                        ? "gm"
                                        : Details?.wastageType || ""
                                  }`}
                              </div>
                            </div>
                            <div className="d-flex justify-content-between py-2 border-bottom">
                              <div>Mc</div>
                              <div>₹ {Details?.netMc || 0}</div>
                            </div>
                          </div>
                        </section>
                      </div> */}

                  {/* </div> */}
                  {/* </div> */}

                </div>

                <div className="mt-0" tw="sm:py-0 py-10" style={{ marginLeft: "200px" }}>
                  {/* <h2 tw="pb-2 uppercase">{Details.productName}</h2> */}


                  <div className="row py-4">
                    {Details.status !== "Sale" ? (''
                      // <BookAppointmentButton category={Details} />
                    ) : (
                      <>
                        {/* <Pincode /> */}
                        {/* <BookAppointmentButton category={Details} /> */}
                        {!!isShow && (
                          <>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-6">
                  <Skeleton tw="w-full h-full" />
                </div>
                <div className="col-md-6">
                  <Skeleton tw="pb-2 uppercase w-3/4 sm:h-1/12 h-0 mt-2 mb-0" />
                  <div className="row mx-2">
                    <table tw="leading-9" className="col-md-6">
                      <tr tw="mb-3">
                        <Skeleton tw="w-full" />
                      </tr>
                      <tr>
                        <Skeleton tw="w-full" />
                      </tr>
                      <tr>
                        <Skeleton tw="w-full" />
                      </tr>
                    </table>
                    <div className="col-md-6">
                      <div tw="mt-1">
                        <Skeleton tw="w-5/12" />
                        <Skeleton tw="w-5/12 my-4" />
                        <Skeleton tw="w-5/12" />
                      </div>
                    </div>
                  </div>
                  <div className="py-2">
                    <div tw="mt-1">
                      <Skeleton tw="uppercase w-3/4 " />
                    </div>
                  </div>
                  <div tw="text-green-600 py-1">
                    <h6>
                      <Skeleton tw="w-5/12" />
                    </h6>
                  </div>
                  <p tw="text-sm">
                    <Skeleton tw="w-6/12" />
                  </p>
                  <Skeleton tw="w-4/12 my-3" />
                  <table className="table table-bordered">
                    <Skeleton count={3} tw="w-3/4" />
                  </table>
                  <div className="row">
                    <Skeleton count={3} tw="w-2/4" />
                  </div>
                  <Skeleton tw="w-1/4 h-1/12 mb-20" />
                </div>
              </>
            )}
          </div>
          <a
            href={`https://wa.me/${branch.alternateMobile}?text=${encodeURIComponent(
              `I am interested to buy this product\nTag No: ${Details.productCode}\nBranch: ${Details.branchName}\nProduct Image: ${currentImg}`
            )}`}
            className="scroll-to-top position-fixed bottom-0 end-0 "
            tw="mx-6 my-20"
            target="_blank"
            rel="noreferrer"
          >
            <div className="rounded-circle text-white p-1" style={{ cursor: "pointer", backgroundColor: "#25d366" }} >
              <i className="bi bi-whatsapp px-2 fs-2" style={{ fontSize: "11px" }} ></i>
            </div>
          </a>
        </div>
      </section>
      <div style={{ marginTop: "-50px" }}>
        <RelatedProduct Details={Details} categoryId={catId} />
      </div>

    </StyledDiv>
  );
};